module.exports = require("pouchdb-find");


//////////////////
// WEBPACK FOOTER
// external "pouchdb-find"
// module id = 22
// module chunks = 0